var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('donation-groups'),_c('title-name'),_c('notes-text'),_c('report-hidden'),(_vm.dataItem.id_donation_groups)?[_c('donation-types')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }